export const PageComponents = () => {
  return <div>Components</div>;
}
